<div class="container">
  <img class="responsive-img z-depth-2" src="{{ image }}" *ngFor="let image of introImages" />
</div>
